export const SET_SLIDE_UP_MODAL_STATE: string = 'SET_SLIDE_UP_MODAL_STATE';
